export default __webpack_public_path__ + "img/cVZAuJiw.e989292d.svg";